import { sha256 } from '@noble/hashes/sha256';
import { Buffer } from 'buffer';

export async function hmac(plainText: string, password: string) {
  const ptBuffer = Buffer.from(plainText);

  const pwBuffer = Buffer.from(password);

  const pwHash = await window.crypto.subtle.digest('SHA-256', pwBuffer);

  const key = await window.crypto.subtle.importKey(
    'raw',
    pwHash,
    { name: 'HMAC', hash: { name: 'SHA-256' } },
    false,
    ['sign'],
  );

  const hmacBuffer = await window.crypto.subtle.sign('HMAC', key, ptBuffer);

  return Buffer.from(hmacBuffer).toString('hex');
}

export const buffer2hex = (buffer: ArrayBuffer) =>
  Array.prototype.map
    .call(new Uint8Array(buffer), (x) => `00${x.toString(16)}`.slice(-2))
    .join('');

export function bytesToHex(bytes: Uint8Array) {
  let hex = '';
  for (let i = 0; i < bytes.length; i += 1) {
    hex += bytes[i].toString(16).padStart(2, '0');
  }
  return hex;
}

export function hexToBytes(hex: string) {
  hex = hex.length & 1 ? `0${hex}` : hex;
  const array = new Uint8Array(hex.length / 2);
  for (let i = 0; i < array.length; i += 1) {
    const j = i * 2;
    const byte = Number.parseInt(hex.slice(j, j + 2), 16);
    if (Number.isNaN(byte)) {
      throw new Error(`Invalid hex byte at position ${j}`);
    }
    array[i] = byte;
  }
  return array;
}

export function isValidBip0276Address(address: string) {
  if (typeof address !== 'string') {
    return false;
  }
  if (!address.startsWith('bitcoin-script:')) {
    return false;
  }

  if (address.length < 15 + 4 + 8 + 2) {
    throw new Error('BIP-0276 address too short');
  }
  const bytes = hexToBytes(address.slice(15));
  if (bytes[0] !== 1) {
    throw new Error(`BIP-0276 version ${bytes[0]} unsupported`);
  }
  if (bytes[1] !== 1) {
    throw new Error('BIP-0276 address not on mainnet');
  }

  const addressBytes = new TextEncoder().encode(address.slice(0, -8));
  const expectedChecksum = sha256(sha256(addressBytes)).slice(0, 4);
  const checksum = bytes.slice(-4);
  if (expectedChecksum.some((byte, index) => checksum[index] !== byte)) {
    throw new Error('BIP-0276 address checksum mismatch');
  }
  return true;
}
